import { Component } from 'react';
import { compose } from 'recompose';
import { ChartFragment, Section } from 'models/api-response';
import { FormFieldInputType } from 'models/enum';
import { ChartActionsComponentProps, ChartComponentProps, ChartMetaFormField } from 'models/ui';
import { chartHelper } from 'helpers';
import { chartService } from 'services';
import { withChartLogic } from 'components/common';
import withSavedPatientChartsPage from 'components/features/shared/withSavedPatientChartsPage';
import { FormField, SectionTitle } from './constants';
import NutritionHydrationView from './NutritionHydrationView';
import { Title } from '../shared/constants';

class NutritionHydration extends Component<ChartComponentProps> {
  static displayName = 'NutritionHydration';

  componentDidMount() {
    this.props.initState(this.buildDefaultFormFields());
  }

  buildDefaultFormFields = (): Map<string, ChartMetaFormField> => {
    const { createFormField } = chartHelper;
    const dataMap = new Map();

    const checkBoxes = [FormField.NO_ASSESSMENT_REQUIRED];
    const multiselectDropdowns = [FormField.NUTRITION_CARE_LIST, FormField.HYDRATION_CARE_LIST, FormField.DIABETIC_CARE_LIST];
    const textAreas = [FormField.NUTRITION_CARE_LIST_NOTES, FormField.HYDRATION_CARE_LIST_NOTES, FormField.DIABETIC_CARE_LIST_NOTES];

    checkBoxes.forEach((name) => dataMap.set(name, createFormField({ name, type: FormFieldInputType.CHECK_BOX })));
    multiselectDropdowns.forEach((name) => dataMap.set(name, createFormField({ name, type: FormFieldInputType.MULTISELECT_DROPDOWN })));
    textAreas.forEach((name) => dataMap.set(name, createFormField({ name, type: FormFieldInputType.TEXT_AREA })));

    return dataMap;
  };

  createSections = (): Section[] => {
    const { formFieldMap } = this.props;

    return [
      chartHelper.buildSection({
        sectionTitle: SectionTitle.NUTRITION_HYDRATION_CARE,
        fields: [FormField.NO_ASSESSMENT_REQUIRED],
        formFieldMap
      }),
      chartHelper.buildSection({
        sectionTitle: SectionTitle.NUTRITION_CARE,
        fields: [FormField.NUTRITION_CARE_LIST, FormField.NUTRITION_CARE_LIST_NOTES],
        formFieldMap
      }),
      chartHelper.buildSection({
        sectionTitle: SectionTitle.HYDRATION_CARE,
        fields: [FormField.HYDRATION_CARE_LIST, FormField.HYDRATION_CARE_LIST_NOTES],
        formFieldMap
      }),
      chartHelper.buildSection({
        sectionTitle: SectionTitle.DIABETIC_CARE,
        fields: [FormField.DIABETIC_CARE_LIST, FormField.DIABETIC_CARE_LIST_NOTES],
        formFieldMap
      })
    ];
  };

  buildFragment = () => {
    const record = {
      chartTitle: Title.BASIC_NURSING_CARE,
      fragmentTitle: SectionTitle.NUTRITION_HYDRATION_CARE,
      records: this.createSections()
    };
    const cleanRecord = chartService.systemAssessment.removeEmptyRecords(record);
    const basicInfo = chartService.createBaseFragment({ chartingTime: this.props.chartingTime });
    return { ...basicInfo, chartData: cleanRecord } as ChartFragment;
  };

  handleSaveClick = () => {
    this.props.saveChart([this.buildFragment()], { afterSave: this.props.backToSourceLocation || this.props.navigateToSavedPatientCharting });
  };

  render() {
    const chartActionsProps: ChartActionsComponentProps = {
      enableDisplayRecordsButton: this.props.enableDisplayRecordsButton,
      enableSaveButton: this.props.hasUnsavedChanges,
      onCancelClick: () => this.props.handleDiscardClick(undefined, this.buildDefaultFormFields()),
      onDisplayRecordsClick: this.props.displayAuthoringData,
      onSaveClick: this.handleSaveClick
    };
    const viewProps = {
      chartActionsProps,
      formFieldMap: this.props.formFieldMap,
      formSubmittedCount: this.props.formSubmittedCount
    };
    return <NutritionHydrationView {...viewProps} />;
  }
}
export { NutritionHydration as BaseNutritionHydration };
export default compose(withSavedPatientChartsPage, withChartLogic)(NutritionHydration);
